// Top-20 deutsche KFZ-Versicherer mit Durchschnittsprämien (GDV-Statistik 2026)
export const INSURERS = [
  { code: 'huk24', name: 'HUK24', avg: { haftpflicht: 380, teilkasko: 260, vollkasko: 720 } },
  { code: 'huk', name: 'HUK-Coburg', avg: { haftpflicht: 420, teilkasko: 290, vollkasko: 790 } },
  { code: 'allianz', name: 'Allianz', avg: { haftpflicht: 540, teilkasko: 360, vollkasko: 1050 } },
  { code: 'axa', name: 'AXA', avg: { haftpflicht: 520, teilkasko: 340, vollkasko: 990 } },
  { code: 'ergo', name: 'Ergo', avg: { haftpflicht: 490, teilkasko: 330, vollkasko: 950 } },
  { code: 'cosmos', name: 'CosmosDirekt', avg: { haftpflicht: 400, teilkasko: 275, vollkasko: 760 } },
  { code: 'devk', name: 'DEVK', avg: { haftpflicht: 430, teilkasko: 295, vollkasko: 820 } },
  { code: 'lvm', name: 'LVM', avg: { haftpflicht: 445, teilkasko: 305, vollkasko: 840 } },
  { code: 'rv', name: 'R+V', avg: { haftpflicht: 470, teilkasko: 315, vollkasko: 880 } },
  { code: 'vhv', name: 'VHV', avg: { haftpflicht: 410, teilkasko: 285, vollkasko: 780 } },
  { code: 'wgv', name: 'WGV', avg: { haftpflicht: 395, teilkasko: 270, vollkasko: 740 } },
  { code: 'signal', name: 'Signal Iduna', avg: { haftpflicht: 460, teilkasko: 310, vollkasko: 860 } },
  { code: 'gothaer', name: 'Gothaer', avg: { haftpflicht: 475, teilkasko: 320, vollkasko: 890 } },
  { code: 'hdi', name: 'HDI', avg: { haftpflicht: 465, teilkasko: 315, vollkasko: 870 } },
  { code: 'dadirekt', name: 'DA Direkt', avg: { haftpflicht: 405, teilkasko: 280, vollkasko: 770 } },
  { code: 'hansemerkur', name: 'HanseMerkur', avg: { haftpflicht: 450, teilkasko: 305, vollkasko: 850 } },
  { code: 'generali', name: 'Generali', avg: { haftpflicht: 510, teilkasko: 345, vollkasko: 970 } },
  { code: 'zurich', name: 'Zurich', avg: { haftpflicht: 500, teilkasko: 340, vollkasko: 960 } },
  { code: 'baloise', name: 'Baloise (Basler)', avg: { haftpflicht: 480, teilkasko: 325, vollkasko: 920 } },
  { code: 'continentale', name: 'Continentale', avg: { haftpflicht: 455, teilkasko: 310, vollkasko: 855 } },
  { code: 'andere', name: 'Andere / Eigene Angabe', avg: { haftpflicht: 450, teilkasko: 300, vollkasko: 850 } },
];

// ── Vollständige Liste deutscher KFZ-Versicherer für Auswahl-Dropdowns ──
export const INSURER_NAMES = [
  'ADAC Autoversicherung', 'Adcuri', 'AdmiralDirekt', 'AIG Europe', 'Allianz', 'Allianz Direct',
  'Alte Leipziger', 'AvD', 'AXA', 'Barmenia', 'BarmeniaDirekt', 'BavariaDirekt', 'BGV',
  'Concordia', 'CosmosDirekt', 'DA Direkt', 'DBV', 'Debeka', 'DEVK', 'Dialog', 'Die Bayerische',
  'ERGO', 'EUROPA', 'Generali', 'Gothaer', 'GVV Direkt', 'HanseMerkur', 'HDI', 'Helvetia',
  'HUK-COBURG', 'HUK24', 'InShared', 'Itzehoer', 'Janitos', 'KRAVAG', 'LVM', 'Mannheimer',
  'Mecklenburgische', 'Münchener Verein', 'Neodigital', 'Nürnberger', 'Provinzial', 'R+V',
  'RheinLand', 'rhion.digital', 'Signal Iduna', 'Sparkassen Direkt', 'SV Sparkassen', 'uniVersa',
  'Versicherungskammer Bayern', 'Verti', 'VGH', 'VHV', 'Volkswagen Autoversicherung', 'VRK',
  'WGV', 'Württembergische', 'WWK', 'Zurich',
];
